/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useState } from "react";
import Button, { Icons } from "../buttons/Button";
import CopyButton from "../buttons/CopyButton";
import { errorAlert, successAlert } from "../../util";

import AuthContext from "../../store/authContext";
import InlineLoader from "../loader/InlineLoader";
import AlarmMetaData from "./AlarmMetaData";
import {
  LOADING_TEXT_TRANSLATIONS,
  READ_ACTIVE_ALARM,
} from "../../translations/util";

interface IProps {
  setShowEditPanel: any;
  org: string;
  panelName: string;
  esRef: string;
  formFields: any;
  transformResponseRow: any;
  loadDataByRef: any;
  addComment?: any;
}

const ViewAlarmRow = ({
  setShowEditPanel,
  esRef,
  org,
  panelName,
  formFields,
  transformResponseRow,
  loadDataByRef,
  addComment,
}: IProps) => {
  const { token } = useContext(AuthContext);
  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState(null);

  const getDataByRef = async (ref: string) => {
    if (org && token) {
      setDataLoading(true);
      try {
        const response = await loadDataByRef({
          token,
          org,
          ref,
        });
        setData(transformResponseRow(response));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (e: any) {
        errorAlert(e);
      } finally {
        setDataLoading(false);
      }
    }
  };

  const addAlarmComment = async (content: string) => {
    if (token) {
      setDataLoading(true);
      try {
        await addComment({
          token,
          content,
          ref: esRef,
        });
        successAlert(READ_ACTIVE_ALARM.successAlertMessage);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (e: any) {
        errorAlert(e);
      } finally {
        getDataByRef(esRef);
      }
    }
  };

  useEffect(() => {
    getDataByRef(esRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [esRef]);

  return (
    <aside
      id="sidepanel"
      className="sidepanel sidepanel-view fixed z-40 h-full transform transition-transform ease-in duration-150 bg-white"
      data-cy="view-sidepanel"
    >
      <div className="panel-header">
        <div className="panel-left-side">
          <Button
            kind="ghost"
            className="close-btn"
            icon={Icons.Close}
            onClick={() => setShowEditPanel()}
            dataCy="closeViewSidePanel-"
          />
          <h5 data-cy={`${panelName.replaceAll(" ", "")}`}> {panelName} </h5>
        </div>
      </div>

      <div className="panel-content">
        {dataLoading ? (
          <InlineLoader
            description={LOADING_TEXT_TRANSLATIONS.defaultLoadingText}
          />
        ) : (
          <>
            <ul className="view-data" data-cy="view-data">
              {formFields.map((field: any) => {
                return (
                  <li>
                    <h5 data-cy={`${field.label.replaceAll(" ", "")}`}>
                      {" "}
                      {field.label}{" "}
                    </h5>
                    <div
                      className="data-content"
                      data-cy={`${field.label.replaceAll(" ", "")}-content`}
                    >
                      <span className={field.truncate ? "truncate" : ""}>
                        {data?.[field.name]}
                      </span>
                      {field.hasCopyButton && data?.[field.name] !== "" ? (
                        <CopyButton copyContent={data?.[field.name]} />
                      ) : null}
                    </div>
                  </li>
                );
              })}
            </ul>
            <AlarmMetaData
              additionalData={data?.["ADDITIONAL-INFO"]}
              addAlarmComment={addComment ? addAlarmComment : null}
              // eslint-disable-next-line dot-notation
              comments={data?.["COMMENTS"]}
            />
          </>
        )}
      </div>
    </aside>
  );
};

export default ViewAlarmRow;
